import { DateProvider } from "src/app/_models/DateProvider";

export interface DateProviderState {
    dateProvider: DateProvider;
    loading: boolean;
    error: any | null;
};

export const initialDateProviderState: DateProviderState = {
    dateProvider: null,
    loading: false,
    error: null
};